import { getPlanUsage } from 'rest/dist/gen/api/pricing/pricing';
export async function fetchPlanUsgae() {
  const data = await getPlanUsage();
  return data;
}

// Per-status campaign breakdown (active/scheduled/disabled/expired/conflicted/
// draft) no longer exists server-side — the Campaign feature and its
// /api/dashboard/campaignStatusDetail endpoint were removed for Prime MOQ.
// This keeps the shape callers expect (useCampaignsCount, useUsedVariants,
// useUsagePercents, useDashboardEmptyState, useCampaignsStatusCount) but
// zeroed out, sourcing only the plan-usage totals that still exist.
export async function getCampaignReportByStatusAdaptor() {
  const planUsageData = await getPlanUsage();

  const emptyBucket = {
    campaignCount: 0,
    campaignProductCount: 0,
    campaignVariantCount: 0,
    campaignRevenue: 0,
    campaignOrderCount: 0,
  };

  return {
    data: {
      all: emptyBucket,
      active: emptyBucket,
      schedule: emptyBucket,
      disabled: emptyBucket,
      expire: emptyBucket,
      draft: emptyBucket,
      needUpgrade: {
        campaignCount: 0,
        campaignProductCount: 0,
        campaignVariantCount: 0,
      },
      total: {
        campaignCount: planUsageData?.data?.campaignUsage || 0,
        campaignVariantCount: planUsageData?.data?.variantUsage || 0,
      },
    },
    success: true,
    message: 'ok',
  };
}
